import gql from 'graphql-tag'

export const GET_ROUTE_RECORDS = gql`
  query RouteRecords($filter: GetRouteRecordsFilter) {
    routeRecords(filter: $filter) {
      isSuccessful
      message
      routeRecords {
        pagination {
          endCursor
          page
          show
          startCursor
          total
        }
        data {
          missedRoutes {
            data {
              createdOn
              latitude
              longitude
            }
            total
          }
          distanceDriven
          endOn
          expectedEndOn
          expectedStartOn
          route {
            name
            routeId
            status
          }
          routeRecordId
          startOn
          status
          vehicle {
            id
            imei
            licensePlate
            vehicleType {
              model
              type
              icon
            }
          }
        }
      }
      status
    }
  }
`

export const GET_ROUTE_RECORD = gql`
  query RouteRecord($filter: GetRouteRecordFilter!) {
    routeRecord(filter: $filter) {
      isSuccessful
      message
      status
      routeRecord {
        missedRoutes {
          data {
            createdOn
            latitude
            longitude
          }
          total
        }
        distanceDriven
        endOn
        expectedEndOn
        expectedStartOn
        route {
          name
          routeId
          status
        }
        routeRecordId
        startOn
        vehicle {
          id
          imei
          licensePlate
          vehicleType {
            model
            type
            icon
          }
        }
        status
      }
    }
  }
`

export const CREATE_ROUTE_RECORD = gql`
  mutation CreateRouteRecord($input: CreateRouteRecordInput!) {
    createRouteRecord(input: $input) {
      isSuccessful
      message
      errorCode
      errorName
      createRouteRecord {
        endOn
        expectedEndOn
        expectedStartOn
        route {
          name
          status
          routeId
        }
        routeRecordId
        startOn
        status
        vehicle {
          imei
          id
          licensePlate
        }
      }
      status
    }
  }
`

export const UPDATE_STATUS_ROUTE_RECORD = gql`
  mutation UpdateRouteRecord($input: UpdateRouteRecordInput!) {
    updateRouteRecord(input: $input) {
      isSuccessful
      message
      updateRouteRecord {
        endOn
        expectedEndOn
        expectedStartOn
        route {
          name
          status
          routeId
        }
        routeRecordId
        startOn
        status
        vehicle {
          imei
          id
          licensePlate
        }
      }
      status
    }
  }
`

export const UPDATE_ROUTE_RECORD = gql`
  mutation UpdateRouteRecord($input: UpdateRouteRecordInput!) {
    updateRouteRecord(input: $input) {
      isSuccessful
      message
      errorCode
      errorName
      updateRouteRecord {
        endOn
        expectedEndOn
        expectedStartOn
        route {
          name
          status
          routeId
        }
        routeRecordId
        startOn
        status
        vehicle {
          imei
          id
          licensePlate
        }
      }
      status
    }
  }
`

export const ROUTE_RECORD_AUDIT_LOGS = gql`
  query RouteRecordAuditLogs($filter: RouteRecordAuditLogsFilter!) {
    routeRecordAuditLogs(filter: $filter) {
      isSuccessful
      message
      routeRecordAuditLogs {
        data {
          detail
          time
          action
          user
        }
        pagination {
          page
          show
          endCursor
          startCursor
          total
        }
      }
      status
    }
  }
`

export const GET_ROUTE_SETTING = gql`
  query RouteSetting {
    routeSetting {
      isSuccessful
      errorCode
      errorName
      message
      status
      routeSetting {
        licensePlateVisibility
        markerType
      }
    }
  }
`
